import { render, staticRenderFns } from "./singleFilter.vue?vue&type=template&id=b3923a6c&scoped=true"
import script from "./singleFilter.vue?vue&type=script&lang=js"
export * from "./singleFilter.vue?vue&type=script&lang=js"
import style0 from "./singleFilter.vue?vue&type=style&index=0&id=b3923a6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3923a6c",
  null
  
)

export default component.exports